<template>
  <div class="p-0 md:p-2 flex flex-col items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 mb-2">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

            <div class="text-left block">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
            </div>

            <div id="form-fields" class="lg:col-span-2 pb-3">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">

                <!-- registro -->
                <div class="md:col-span-2">
                  <label class="text-left flex pl-1 text-xs text-[#2b3038]">
                    Tipo do registro <a class="text-red-600 ml-1">*</a>
                  </label>
                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="pontoType"
                    :initialValue="store.type"
                    @selected-data="(val) => (store.type = val?.name)"
                  />
                  </div>

                  <span
                    name="type"
                    class="text-red-600 text-sm mt-1"
                  />
                </div>

                <!-- colaborador -->
                <div class="md:col-span-2" v-if="registerToCollab">
                  <label class="text-left flex pl-1 text-xs text-[#2b3038]">
                    Funcionário <a class="text-red-600 ml-1">*</a>
                  </label>
                  <div
                    class="h-10 flex rounded items-center mt-1.5 w-full"
                  >
                  <SimpleSelect
                    :key="store?.collabs"
                    class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
                    :data="store?.collabs"
                    :initialValue="store?.user"
                    @selected-data="(val) => {
                      store.user = val?.name
                      store.user_id = val?.value
                    }"
                  />
                  </div>

                  <span
                    name="type"
                    class="text-red-600 text-sm mt-1"
                  />
                </div>

                <!-- registered time -->
                <div class="md:col-span-2" v-if="registerToCollab">
                  <BaseInput
                    type="time"
                    name="name"
                    v-model="store.registeredTime"
                    :info="'Horario do registro'"
                    label="Horario do registro"
                    :required-field="false"
                    :activeDefault="true"
                  >
                  </BaseInput>
                </div>

                <!-- date -->
                <div class="md:col-span-2" v-if="registerToCollab">
                  <BaseInput
                    type="date"
                    name="name"
                    v-model="store.created_at"
                    :info="'Dia do registro'"
                    label="Dia do registro"
                    :required-field="false"
                    :activeDefault="true"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.created_at = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- observação -->
                <div
                  :class="[
                    !registerToCollab ? 'md:col-span-3' : 'md:col-span-4']"
                >
                  <BaseInput
                    type="text"
                    name="name"
                    v-model="store.obs"
                    :info="'Observação'"
                    label="Observação"
                    :required-field="false"
                    :activeDefault="false"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.obs = undefined"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- funcionário -->
                <div class="md:col-span-5 mt-2 mb-2" :key="registerToCollab">
                  <div class="flex text-base uppercase">
                    <div class="font-thin">
                      <h1>
                        Funcionário: 
                      </h1>
                    </div>
                    <div 
                      class="ml-3 text-xl font-clockFont font-semibold" 
                      v-if="registerToCollab"
                    >
                      {{ store.user }} 
                    </div>
                    <div 
                      class="ml-3 text-xl font-clockFont font-semibold" 
                      v-else
                    >
                      {{ userName }} - {{ userRole }}
                    </div>
                  </div>
                </div>

                <!-- horario do registro -->
                <div class="md:col-span-4">
                  <div class="flex text-base uppercase">
                    <div class="font-thin">
                      <h1>
                        Horario registrado: 
                      </h1>
                    </div>
                    <div class="ml-3 text-xl font-clockFont font-semibold text-green-600">
                      {{ 
                        store.registeredTime
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="p-2 mt-1 mb-1" />

        <div>
          <slot />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CleanInputButton from '../components/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhCloudArrowUp } from '@phosphor-icons/vue'
import { pontoType } from '../lookups/form'
import { dataPonto } from '../store'
import { storeApp } from '@/store'
import { ref } from 'vue'

export default {
  name: 'FormVue',
  components: {
    CleanInputButton,
    BaseInput,
    PhCloudArrowUp,
    SimpleSelect,
  },
  props: {
    descriptionTitle: String
  },
  data () {
    const store = dataPonto.state
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    let permissions = localStorage.getItem('__permissions')
    let permissionArray = permissions?.split(',');
    const registerToCollab = ref(
      permissionArray.includes('pon_to_coll')
    )

    const userName = localStorage.getItem('__user_name');
    const userRole = localStorage.getItem('__user_role');

    return {
      store,
      fileUrl,
      toast,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      pontoType,
      currentTime: new Date().toLocaleTimeString(),
      interval: null,
      storeApp,
      registerToCollab,
      userName,
      userRole
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()

        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          this.store.employee.photo = file
        } else {
          this.selectedFileUrl = undefined
          this.selectedFileName = undefined
          this.store.employee.photo = undefined
          return this.toast(
            'Protege informa: ',
            'Formato inválido, apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitos',
            'info'
          )
        }
      }
    },
    updateClock() {
      this.currentTime = new Date().toLocaleTimeString();
    },
  },
  mounted() {
    this.interval = setInterval(this.updateClock, 1000);
    this.store.registeredTime = this.currentTime
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
}
</script>
